<template>
  <div id="risk-plots" class="transition-plots">
    <div class="buttons">
      <sui-button-group class="left">
        <sui-button
          @click="risk = 'favorable'"
          :class="[risk === 'favorable' ? 'active' : 'inactive']"
          >Favorable</sui-button
        >
        <sui-button
          @click="risk = 'intermediate'"
          :class="[risk === 'intermediate' ? 'active' : 'inactive']"
          >Intermediate</sui-button
        >
        <sui-button
          @click="risk = 'adverse'"
          :class="[risk === 'adverse' ? 'active' : 'inactive']"
          >Adverse</sui-button
        >
      </sui-button-group>

      <sui-button-group class="left">
        <sui-button
          @click="timeFromDiagnosis = true"
          :class="[timeFromDiagnosis ? 'active' : 'inactive']"
          >from Diagnosis</sui-button
        >
        <sui-button
          @click="timeFromDiagnosis = false"
          :class="[!timeFromDiagnosis ? 'active' : 'inactive']"
          >from CR</sui-button
        >
      </sui-button-group>

      <sui-button-group class="right">
        <sui-button
          @click="showCIErrors = true"
          :class="[showCIErrors ? 'active' : 'inactive']"
          >Show 95% CI</sui-button
        >
        <sui-button
          @click="showCIErrors = false"
          :class="[!showCIErrors ? 'active' : 'inactive']"
          >Hide</sui-button
        >
      </sui-button-group>
    </div>
    <br />
    <br />
    <br />
    <div class="state-plot-container">
      <h2 v-show="this.averageLoading" class="title">
        Average
        <span :class="['ui label title-label', risk]">{{
          risk.toUpperCase()
        }}</span>
        Patient in ELN 2017 Risk Score
        <br />
        <img class="loading" src="../assets/loader.gif" />
        <img class="placeholder" src="../assets/placeholder.png" />
      </h2>

      <div v-show="!this.averageLoading">
        <h2 class="title">
          Average
          <span :class="['ui label title-label', risk]">{{
            risk.toUpperCase()
          }}</span>
          Patient in ELN 2017 Risk Score
        </h2>
        <div id="eln-chart" class="center-flex"></div>
      </div>
    </div>

    <div class="state-plot-container">
      <h2 v-show="this.averageLoading" class="title">
        Average
        <span :class="['ui label title-label', risk]">{{
          risk.toUpperCase()
        }}</span>
        Patient in Proposal Risk Score
        <br />
        <img class="loading" src="../assets/loader.gif" />
        <img class="placeholder" src="../assets/placeholder.png" />
      </h2>

      <div v-show="!this.averageLoading">
        <h2 class="title">
          Average
          <span :class="['ui label title-label', risk]">{{
            risk.toUpperCase()
          }}</span>
          Patient in Proposal Risk Score
        </h2>
        <div id="new-chart" class="center-flex"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import transitionMixin from "@/mixins/transition";

const selectorsMap = {
  eln: "#eln-chart",
  new: "#new-chart"
};

export default {
  name: "RiskPlots",
  data() {
    return {
      averageLoadingo: true,
      d3: this.$d3,
      selectorsMap: selectorsMap,
      selector: "#risk-plots",
      timeFromDiagnosis: true,
      risk: "favorable",
      elements: {
        eln: {},
        new: {}
      }
    };
  },
  mounted() {
    this.renderPlots();
  },
  watch: {
    plots() {
      this.renderPlots();
    },
    timeFromDiagnosis() {
      this.updateBarPlots(1);
    },
    risk() {
      this.updateBarPlots(1);
    }
  },
  computed: {
    ...mapGetters(["averageRisk", "averageLoading"]),
    plots() {
      const data = this.averageRisk;
      const xlabel = this.timeFromDiagnosis ? "Diagnosis" : "CR";
      const elnData =
        xlabel === "Diagnosis"
          ? data[`ELN_${this.risk}_diagnosis`]
          : data[`ELN_${this.risk}_CR`];
      const newData =
        xlabel === "Diagnosis"
          ? data[`NEW_${this.risk}_diagnosis`]
          : data[`NEW_${this.risk}_CR`];

      const plots = [
        // ELN classification
        {
          data: elnData,
          type: "eln",
          xlabel
        },
        // NEW classification
        {
          data: newData,
          type: "new",
          xlabel
        }
      ];
      return data ? plots : [];
    }
  },
  mixins: [transitionMixin]
};
</script>

<style lang="scss"></style>
